import React, { useState } from "react";
import { useFormikContext, getIn } from "formik";
import { SketchPicker } from "react-color";
import { Icons } from "assets/icons";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const CustomColorField = ({
  label,
  name,
  placeholder = "#FFFFFF",
  className = "",
  infoText = null,
}) => {
  const { info } = Icons || {};
  const { values, touched, errors, setFieldValue } = useFormikContext();

  const value = getIn(values, name);
  const fieldTouched = getIn(touched, name);
  const fieldError = getIn(errors, name);

  const [showPicker, setShowPicker] = useState(false);

  return (
    <div className="w-100 position-relative">
      {label && (
        <label htmlFor={name}>
          {label}{" "}
          {infoText && (
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip>{infoText}</Tooltip>}
            >
              <img
                src={info}
                alt="info"
                width={15}
                height={15}
                style={{ cursor: "pointer" }}
              />
            </OverlayTrigger>
          )}
        </label>
      )}

      {/* Preview + input */}
      <div
        className={`form-control d-flex align-items-center gap-2 ${
          fieldTouched && fieldError ? "is-invalid" : ""
        } ${className}`}
        style={{ cursor: "pointer" }}
        onClick={() => setShowPicker(!showPicker)}
      >
        <div
          style={{
            width: 28,
            height: 28,
            borderRadius: 6,
            border: "1px solid #ccc",
            backgroundColor: value || "#ffffff",
          }}
        />
        <span>{value || placeholder}</span>
      </div>

      {/* Color Picker */}
      {showPicker && (
        <div
          style={{
            position: "absolute",
            zIndex: 20,
            marginTop: 10,
          }}
        >
          {/* Click outside */}
          <div
            style={{
              position: "fixed",
              inset: 0,
            }}
            onClick={() => setShowPicker(false)}
          />

          <SketchPicker
            color={value || "#ffffff"}
            onChangeComplete={(color) =>
              setFieldValue(name, color.hex.toUpperCase())
            }
          />
        </div>
      )}

      {fieldTouched && fieldError && (
        <div className="text-danger">{fieldError}</div>
      )}
    </div>
  );
};

export default CustomColorField;
